import React, { useContext } from "react";
import { CheckLabel } from "@sscs/ui";
import { reproID } from "../../../constants";
import { selectScrollTo } from "../../../store/sdlcReportSlice";
import { ReportContext } from "../../context";
import DiffHeader from "../../diff/common/DiffHeader/DiffHeader";
import { useReportSelector, useScrollIntoView } from "../../hooks";
import { useGetDiffSummaryQuery } from "../../services/diff.api";
const REPRO_CHECK_TEXT = {
    "repro-check-fail": "Reproducibility check failed which may suggest security compromise. Investigate root cause.",
    "repro-check-pass": "The reproducible build matches the reference version.",
    "repro-not-checked": "Reproducibility check was not performed",
};
const ReproCheckHeader = ({ modifiedInfo, }) => {
    const scrollTo = useReportSelector(selectScrollTo);
    const { diffId } = useContext(ReportContext);
    const { data } = useGetDiffSummaryQuery({ ui_id: diffId });
    useScrollIntoView(scrollTo, reproID);
    if (!data)
        return React.createElement("div", { id: reproID });
    const failed = data.reproducible === "repro-check-fail";
    return (React.createElement(DiffHeader, { id: reproID, title: "Reproducibility", statusLabel: React.createElement(CheckLabel, { status: failed ? "fail" : "pass", isReproducibilityCheck: true }), failed: failed, description: REPRO_CHECK_TEXT[data.reproducible], glyph: "equality", files: [
            {
                id: "diff-repro-copy-hash-to-clipboard",
                label: "Reproducible build",
                info: modifiedInfo,
            },
            {
                id: "diff-version-copy-hash-to-clipboard",
                label: "Reference version",
                info: data.source,
            },
        ] }));
};
export default ReproCheckHeader;
//# sourceMappingURL=ReproCheckHeader.js.map